/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const calculateDiscountComboModifierRequestSchema = z
	.object({
		id: z.uuid(),
		amount: z.int().min(1),
	})
	.describe("Базовый сериализатор рассчета скидки по позициям.");
